import React from "react";
import { useInView } from "react-intersection-observer";

// components
import Cards from "./Cards/Cards";

// css
import * as styles from "./HowTwinWork.module.css";

const HowTwinWorkComponent = ({ cardsData, onArrowClick }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section className={styles.howTwinWorkWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.headerSection}>
              <h1 className={styles.mainTitle}>How Twin Health Works</h1>
              <p className={styles.mainDescription}>
                The AI Digital Twin™ uses AI to track your metabolic health
                insights, seeing how your unique biology responds to your
                routine. This precision guidance helps restore metabolic
                balance, supporting diabetes remission and PMOS
                improvement—healing the root cause, not just symptoms
              </p>
            </div>
          </div>
          <div className="col-12">
            <div className="row">
              <div className="col-12 col-md-4">
                <div className={styles.approachSection}>
                  <h3 className={styles.approachTitle}>
                    A Step-by-Step Approach
                  </h3>
                </div>
              </div>
              {/* Cards Section */}
              <div className="col-12 col-md-8">
                <Cards
                  cardsData={cardsData}
                  onArrowClick={onArrowClick}
                  visibleCardCount={2}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowTwinWorkComponent;
